import styled from 'styled-components'

export const Wrapper = styled.div`
    .fb-post {
        max-width: 100%;

        iframe,
        span {
            max-width: 100%;
        }
    }
`
